module.exports = __webpack_public_path__ + "img/screen4.89e928d2.jpg";